<div class="relativePageContainer">
  <div class="page-container">
    <div [ngClass]="isDrawerOpen? '' : 'noShadowOverlay'" class="dx-card">
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [(opened)]="isDrawerOpen"
        [className]="'drawerParent'"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'slide'"
        template="template">
        <div #drawerInnerContent *dxTemplate="let data of 'template'" [style.width.px]="setWidthOfDrawerPx()"
             class="drawerInnerContent" style="border-radius: 10px;">
          <div *ngIf="!!selectedDeviceType" [style.width.px]="setWidthOfDrawerPx()" class="drawerContainer">
            <div #deviceTypeName class="drawerTitleWrapper" id="deviceTypeName">
              <h2>{{ selectedDeviceType.modelName }}</h2>
              <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                           id="editDeviceTypeButton"
                           text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
                <dx-button (onClick)="deletingDeviceType = true" *ngIf="!isEditMode" icon="trash"
                           text="{{'BUTTONS.DELETE' | translate}}"
                           type="danger"></dx-button>
                <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                  <dx-button (onClick)="saveDeviceType();"
                             [disabled]="!isEditFormValid || !deviceTypeEdited" [stylingMode]="'contained'"
                             [type]="'default'"
                             icon="save" text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                  <dx-button
                    (onClick)="disableEditMode();" [type]="'normal'" [stylingMode]="'contained'"
                    icon="revert" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
                </div>
                <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                           [width]="30"
                           icon="close"></dx-button>
              </div>
            </div>

            <div>
              <dx-form #editDeviceTypeForm
                       (onFieldDataChanged)="checkEditDeviceTypeValidation()"
                       (onOptionChanged)="checkEditDeviceTypeValidation()"
                       [formData]="editedDeviceType"
                       [height]="'100%'"
                       [labelLocation]="'top'"
                       [labelMode]="'floating'"
              >
                <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
                  <span>{{ tab.title }}</span>
                  <div *ngIf="!checkTabValidity(tab, editDeviceTypeForm)" class="invalidBadge">!</div>
                  <app-row-state-badge *ngIf="tab.title === ('REGISTRY.DEVICE_TYPE.TABS.METRICS' | translate)"
                                       [trackers]="metricsRowStateTrackers"></app-row-state-badge>
                </div>
                <dxi-item itemType="tabbed">
                  <dxo-tab-panel-options [deferRendering]="false"
                                         [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.DEVICE_TYPE.TABS.INFORMATION' | translate}}">
                    <dxi-item [editorOptions]="deviceTypeEditTextOptions" dataField="modelName">
                      <dxo-label text="{{'REGISTRY.DEVICE_TYPE.MODEL_NAME' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.NAME' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="deviceTypeEditTextOptions" dataField="partNumber">
                      <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxo-label text="{{'REGISTRY.DEVICE_TYPE.PART_NUMBER' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="deviceTypeEditDelayMSOptions" dataField="modbusWritePauseMillis" editorType="dxNumberBox">
                      <dxi-validation-rule [max]="gmService.MAX_MODBUS_WRITE_PAUSE_MS"
                                           [min]="gmService.MIN_MODBUS_WRITE_PAUSE_MS"
                                           message="{{ 'REGISTRY.DEVICE_TYPE.DELAY_OUTSIDE_RANGE' | translate}}"
                                           type="range"></dxi-validation-rule>
                      <dxi-validation-rule
                        *ngIf="editedDeviceType?.protocolType !== ProtocolTypeEnum.SIEMENS_S7"
                        message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.DELAY_MS' | translate}}"
                        type="required"></dxi-validation-rule>
                      <dxo-label text="{{'REGISTRY.DEVICE_TYPE.DELAY_MS' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="{
                      dataSource: this.manufacturers,
                      displayExpr: 'name',
                      valueExpr: 'id',
                      disabled: !this.isEditMode,
                      acceptCustomValue: true,
                      onCustomItemCreating: addNewManufacturer,
                      itemTemplate: 'manufacturerItemTemplate'
                    }" dataField="manufacturer.id"
                              editorType="dxSelectBox"
                    >
                      <dxo-label text="{{'REGISTRY.DEVICE_TYPE.MANUFACTURER' | translate}}"></dxo-label>
                      <dxi-validation-rule message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.MANUFACTURER' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="{
                      dataSource: gmService.protocolTypeValues,
                      displayExpr: 'label',
                      valueExpr: 'value',
                      disabled: !this.isEditMode || checkIfUserCanChangeProtocol(this.editedDeviceType),
                      onValueChanged: onEditProtocolTypeChanged
                  }" dataField="protocolType"
                              [helpText]="this.isEditMode && checkIfUserCanChangeProtocol(this.editedDeviceType)? translate.instant('REGISTRY.DEVICE_TYPE.CANT_CHANGE_PROTOCOL') : undefined "
                              editorType="dxSelectBox"
                    >
                      <dxo-label text="{{'REGISTRY.DEVICE_TYPE.PROTOCOL_TYPE' | translate}}"></dxo-label>
                      <dxi-validation-rule message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.PROTOCOL_TYPE' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>
                  </dxi-tab>

                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.DEVICE_TYPE.TABS.METRICS' | translate}}">
                    <dxi-item dataField="groups" style="gap: 10px; display: flex; flex-direction: column;">
                      <div *dxTemplate>
                        <div
                          style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 0; left: 0; right: 0;gap: 10px;padding: 20px;">
                          <app-modbus-group-table
                            #modbusGroupTable
                            [metricRowStateTracker]="editMetricRowStateTracker"
                            (metricEditBlocked)="focusActiveMetricEdit()"
                            *ngIf="editedDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_TCP
                                      || editedDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_RTU"
                            style="overflow: hidden;flex: 1 1 40%"
                            (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                            [(isEditMode)]="isEditMode"
                            [(groupIsBeingEdited)]="groupIsBeingEdited"
                            [(dataUnitValues)]="dataUnitValues"
                            [(selectedGroupMetric)]="selectedGroupMetric!"
                            [(selectedGroupMetricRow)]="selectedGroupMetricRow"
                            [(deviceType)]="this.editedDeviceType!"
                            [(groupMetric)]="editedGroupMetric">
                          </app-modbus-group-table>
                          <app-s7-group-table
                            #s7GroupTable
                            [metricRowStateTracker]="editMetricRowStateTracker"
                            (metricEditBlocked)="focusActiveMetricEdit()"
                            *ngIf="editedDeviceType?.protocolType === ProtocolTypeEnum.SIEMENS_S7"
                            style="overflow: hidden;flex: 1 1 40%"
                            (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                            [(isEditMode)]="isEditMode"
                            [(groupIsBeingEdited)]="groupIsBeingEdited"
                            [(dataUnitValues)]="dataUnitValues"
                            [(selectedGroupMetric)]="selectedGroupMetric!"
                            [(selectedGroupMetricRow)]="selectedGroupMetricRow"
                            [(deviceType)]="this.editedDeviceType!"
                            [(groupMetric)]="editedGroupMetric">
                          </app-s7-group-table>
                          <app-modbus-metric-table
                            #modbusMetricTable
                            [rowStateTracker]="editMetricRowStateTracker"
                            *ngIf="editedDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_TCP
                                   || editedDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_RTU"
                            style="overflow: hidden; flex: 1 1 60%"
                            (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                            [(dataUnitValues)]="dataUnitValues"
                            [(groupIsBeingEdited)]="groupIsBeingEdited"
                            [(groupMetric)]="editedGroupMetric"
                            [(isEditMode)]="isEditMode"
                            [(metricIsBeingEdited)]="metricIsBeingEdited">
                          </app-modbus-metric-table>
                          <app-s7-metric-table
                            #s7MetricTable
                            [rowStateTracker]="editMetricRowStateTracker"
                            *ngIf="editedDeviceType?.protocolType === ProtocolTypeEnum.SIEMENS_S7"
                            style="overflow: hidden; flex: 1 1 60%"
                            (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                            [(dataUnitValues)]="dataUnitValues"
                            [(groupIsBeingEdited)]="groupIsBeingEdited"
                            [(groupMetric)]="editedGroupMetric"
                            [(isEditMode)]="isEditMode"
                            [(metricIsBeingEdited)]="metricIsBeingEdited">
                          </app-s7-metric-table>
                        </div>
                      </div>

                    </dxi-item>
                  </dxi-tab>
                </dxi-item>

                <div *dxTemplate="let data of 'manufacturerItemTemplate'" class="custom-item">
                  <div class="manufacturer-item">
                    <span>{{ data.name }}</span>
                    <dx-button (onClick)="deleteManufacturer(data, $event)" icon="trash" stylingMode="text"
                               type="default"></dx-button>
                  </div>
                </div>

              </dx-form>
            </div>


          </div>

        </div>

        <div class="drawerOuterContent">

          <dx-data-grid
            (onRowClick)="onDeviceTypeRowClick($event)"
            [(selectedRowKeys)]="selectedRowDeviceType"
            [columnAutoWidth]="true"
            [dataSource]="deviceTypes"
            [showBorders]="true"
            [showRowLines]="false"
            [wordWrapEnabled]="true"
            height="100%"
            id="deviceTypeTree"
            keyExpr="id"
          >

            <dxo-toolbar>
              <dxi-item location="before">
                <p
                  style="font-size: 22px; margin: 0 0 0 10px; white-space: nowrap;">{{ 'MENU_VOICE.REGISTRY.DEVICE_TYPES' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
              </dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewDeviceTypeForm()" hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-paging
              [enabled]="false">
            </dxo-paging>

            <dxo-scrolling
              mode="standard">
            </dxo-scrolling>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
            </dxo-search-panel>
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.MODEL_NAME' | translate}}" dataField="modelName"></dxi-column>
            <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.PART_NUMBER' | translate}}"
                        dataField="partNumber"></dxi-column>
            <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.MANUFACTURER' | translate}}"
                        dataField="manufacturerName"></dxi-column>
            <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.PROTOCOL_TYPE' | translate}}"
                        dataField="protocolType"></dxi-column>
            <dxi-column caption="" cellTemplate="actionsTemplate" type="buttons"></dxi-column>

            <div *dxTemplate="let data of 'actionsTemplate'" style="display: flex; justify-content: center; gap: 10px">
              <i (click)="$event.stopPropagation(); openDuplicateDeviceType(data.data);"
                 [matTooltip]="'REGISTRY.DEVICE_TYPE.TOOLTIP.DUPLICATE' | translate"
                 class="dx-icon-copy custom-action-icon"></i>
            </div>

          </dx-data-grid>

          <dx-popup
            [visible]="!!duplicatingDeviceType"
            (onHiding)="duplicatingDeviceType = undefined"
            [dragEnabled]="false"
            [fullScreen]="appService.isSmallScreen()"
            [focusStateEnabled]="false"
            [height]="220"
            [hideOnOutsideClick]="true"
            [showCloseButton]="false"
            [showTitle]="true"
            [title]="'REGISTRY.DEVICE_TYPE.TEXT.DUPLICATE_DEVICE_TYPE' | translate"
            [width]="660">
            <dxi-toolbar-item
              location="after"
              toolbar="bottom">
              <dx-button
                (onClick)="duplicateDeviceType()"
                [disabled]="!duplicateDeviceTypeName"
                [height]="40"
                [stylingMode]="'contained'"
                icon="copy"
                text="{{'REGISTRY.DEVICE_TYPE.BUTTONS.DUPLICATE' | translate}}"
                type="default">
              </dx-button>
            </dxi-toolbar-item>
            <dxi-toolbar-item
              location="after"
              toolbar="bottom">
              <dx-button
                (onClick)="duplicatingDeviceType = undefined"
                [height]="40"
                [stylingMode]="'outlined'"
                icon="close"
                text="{{'BUTTONS.CANCEL' | translate}}">
              </dx-button>
            </dxi-toolbar-item>

            <div style="height: 100%; display: flex; align-items: center;">
              <dx-text-box
                [(value)]="duplicateDeviceTypeName"
                [maxLength]="gmService.STR_DIM_MID"
                [label]="'REGISTRY.DEVICE_TYPE.TEXT.DUPLICATE_DEVICE_TYPE_NAME_LABEL' | translate"
                style="width: 100%;">
              </dx-text-box>
            </div>
          </dx-popup>


        </div>

      </dx-drawer>

    </div>
  </div>
</div>

<dx-popup
  (onHiding)="addDeviceType = false; metricIsBeingEdited = false; groupIsBeingEdited = false;"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="false"
  [fullScreen]="appService.isSmallScreen()"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.DEVICE_TYPE.TEXT.ADD_DEVICE_TYPE' | translate"
  [visible]="addDeviceType"
  [width]="'80vw'"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="createNewDeviceType()" [height]="40"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="addDeviceType = false; selectedGroupMetric = undefined; editedGroupMetric = undefined"
               [height]="40"
               [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <dx-form #newDeviceTypeForm *ngIf="addDeviceType"
           [formData]="newDeviceType"
           [labelLocation]="'top'"
           [labelMode]="'floating'"
  >
    <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
      <span>{{ tab.title }}</span>
      <div *ngIf="!checkTabValidity(tab, newDeviceTypeForm)" class="invalidBadge">!</div>
      <app-row-state-badge *ngIf="tab.title === ('REGISTRY.DEVICE_TYPE.TABS.METRICS' | translate)"
                           [trackers]="newMetricsRowStateTrackers"></app-row-state-badge>
    </div>
    <dxi-item itemType="tabbed">
      <dxo-tab-panel-options [deferRendering]="false"
                             [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.DEVICE_TYPE.TABS.INFORMATION' | translate}}">
        <dxi-item [editorOptions]="deviceTypeNewTextOptions" dataField="modelName">
          <dxo-label text="{{'REGISTRY.DEVICE_TYPE.MODEL_NAME' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.NAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceTypeNewTextOptions" dataField="partNumber">
          <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                               type="stringLength"></dxi-validation-rule>
          <dxo-label text="{{'REGISTRY.DEVICE_TYPE.PART_NUMBER' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item
          [editorOptions]="{
              valueChangeEvent: 'keyup',
              disabled: !this.newDeviceType?.protocolType || this.newDeviceType?.protocolType === ProtocolTypeEnum.SIEMENS_S7,
              showClearButton: true
          }"
          dataField="modbusWritePauseMillis"
          editorType="dxNumberBox">
          <dxi-validation-rule
            [max]="gmService.MAX_MODBUS_WRITE_PAUSE_MS"
            [min]="gmService.MIN_MODBUS_WRITE_PAUSE_MS"
            message="{{ 'REGISTRY.DEVICE_TYPE.DELAY_OUTSIDE_RANGE' | translate}}"
            type="range"></dxi-validation-rule>
          <dxo-label text="{{'REGISTRY.DEVICE_TYPE.DELAY_MS' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item [editorOptions]="{
              dataSource: this.manufacturers,
              displayExpr: 'name',
              valueExpr: 'id',
              acceptCustomValue: true,
              onCustomItemCreating: addNewManufacturer,
              itemTemplate: 'manufacturerItemTemplate'
          }" dataField="manufacturer.id" editorType="dxSelectBox">
          <dxo-label text="{{'REGISTRY.DEVICE_TYPE.MANUFACTURER' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.MANUFACTURER' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="{
                      dataSource: gmService.protocolTypeValues,
                      disabled: checkIfUserCanChangeProtocol(this.newDeviceType),
                      displayExpr: 'label',
                      valueExpr: 'value',
                      onValueChanged: resetDelayIfNotModbus
              }" dataField="protocolType"
                  [helpText]="checkIfUserCanChangeProtocol(this.newDeviceType)? translate.instant('REGISTRY.DEVICE_TYPE.CANT_CHANGE_PROTOCOL') : undefined "
                  editorType="dxSelectBox">
          <dxo-label text="{{'REGISTRY.DEVICE_TYPE.PROTOCOL_TYPE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.PROTOCOL_TYPE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-tab>

      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.DEVICE_TYPE.TABS.METRICS' | translate}}">
        <dxi-item dataField="groups" style="gap: 10px; display: flex; flex-direction: column;">
          <div *dxTemplate>
            <div
              style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 50px; left: 0; right: 0;gap: 10px;padding: 20px;">
              <app-modbus-group-table
                #newModbusGroupTable
                [metricRowStateTracker]="newMetricRowStateTracker"
                (metricEditBlocked)="focusActiveMetricEdit()"
                *ngIf="newDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_TCP
                       || newDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_RTU"
                style="overflow: hidden;flex: 1 1 40%"
                (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                [isEditMode]="true"
                [(groupIsBeingEdited)]="groupIsBeingEdited"
                [(dataUnitValues)]="dataUnitValues"
                [(selectedGroupMetric)]="selectedGroupMetric!"
                [(selectedGroupMetricRow)]="selectedGroupMetricRow"
                [(deviceType)]="this.newDeviceType!"
                [(groupMetric)]="editedGroupMetric">
              </app-modbus-group-table>
              <app-s7-group-table
                #newS7GroupTable
                [metricRowStateTracker]="newMetricRowStateTracker"
                (metricEditBlocked)="focusActiveMetricEdit()"
                *ngIf="newDeviceType?.protocolType === ProtocolTypeEnum.SIEMENS_S7"
                style="overflow: hidden;flex: 1 1 40%"
                (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                [isEditMode]="true"
                [(groupIsBeingEdited)]="groupIsBeingEdited"
                [(dataUnitValues)]="dataUnitValues"
                [(selectedGroupMetric)]="selectedGroupMetric!"
                [(selectedGroupMetricRow)]="selectedGroupMetricRow"
                [(deviceType)]="this.newDeviceType!"
                [(groupMetric)]="editedGroupMetric">
              </app-s7-group-table>

              <p *ngIf="!newDeviceType?.protocolType"
                 style="text-align: center">
                {{ 'REGISTRY.DEVICE_TYPE.NO_PROTOCOL' | translate }}
              </p>

              <app-modbus-metric-table
                #newModbusMetricTable
                [rowStateTracker]="newMetricRowStateTracker"
                *ngIf="newDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_TCP
                       || newDeviceType?.protocolType === ProtocolTypeEnum.MODBUS_RTU"
                style="overflow: hidden;flex: 1 1 60%"
                (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                [(dataUnitValues)]="dataUnitValues"
                [(groupIsBeingEdited)]="groupIsBeingEdited"
                [(groupMetric)]="editedGroupMetric"
                [isEditMode]="true"
                [(metricIsBeingEdited)]="metricIsBeingEdited">
              </app-modbus-metric-table>
              <app-s7-metric-table
                #newS7MetricTable
                [rowStateTracker]="newMetricRowStateTracker"
                *ngIf="newDeviceType?.protocolType === ProtocolTypeEnum.SIEMENS_S7"
                style="overflow: hidden; flex: 1 1 60%"
                (checkEditDeviceTypeValidation)="checkEditDeviceTypeValidation()"
                [(dataUnitValues)]="dataUnitValues"
                [(groupIsBeingEdited)]="groupIsBeingEdited"
                [(groupMetric)]="editedGroupMetric"
                [isEditMode]="true"
                [(metricIsBeingEdited)]="metricIsBeingEdited">
              </app-s7-metric-table>
            </div>
          </div>
        </dxi-item>
      </dxi-tab>

    </dxi-item>

    <div *dxTemplate="let data of 'manufacturerItemTemplate'" class="custom-item">
      <div class="manufacturer-item">
        <span>{{ data.name }}</span>
        <dx-button (onClick)="deleteManufacturer(data, $event)" icon="trash" stylingMode="text"
                   type="default"></dx-button>
      </div>
    </div>

  </dx-form>

</dx-popup>

<dx-popup
  [(visible)]="deletingDeviceType"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [height]="200"
  [hideOnOutsideClick]="true"
  [fullScreen]="appService.isSmallScreen()"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.DEVICE_TYPE.TEXT.DELETE_DEVICE_TYPE' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deleteDeviceType()" [height]="40" icon="trash" text="{{'BUTTONS.DELETE' | translate}}"
               type="danger"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deletingDeviceType = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.DEVICE_TYPE.TEXT.CONFIRM_DELETE' | translate : {deviceTypeName: selectedDeviceType?.modelName}"
      style="font-size: 18px"></label>
  </div>
</dx-popup>
